import {useEffect, useRef, useState} from 'react';
import {getMidPoint} from '../logic/matchReducer.js';

export const useSwapNotification = (
  swapped,
  gameNumber,
  bestOf,
  points
) => {
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState('');
  const previousSwapped = useRef(swapped);
  const previousGame = useRef(gameNumber);

  useEffect(() => {
    if (swapped === previousSwapped.current) {
      previousGame.current = gameNumber;
      return;
    }

    const changedGame = gameNumber !== previousGame.current;
    const swapReason = changedGame
      ? '局間換邊'
      : `決勝局中途換邊（任一方先到 ${getMidPoint(points)} 分）`;

    setReason(swapReason);
    setShow(true);

    previousSwapped.current = swapped;
    previousGame.current = gameNumber;

    const timer = setTimeout(() => setShow(false), 4000);
    return () => clearTimeout(timer);
  }, [swapped, gameNumber, bestOf, points]);

  return [show, reason, () => setShow(false)];
};